import React, { useState } from "react";

const AccordionList = ({
  sections = [],
  renderItem,
  emptyMessage = "No items available",
  icons,
  type = null,
}) => {
  const [isOpen, setIsOpen] = useState({ 0: true });

  const handleToggle = (index) => {
    setIsOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="mt-[40px] flex flex-col gap-2 ">
      {sections.map(({ title, media, id }, index) => (
        <div
          className="py-6 px-4 bg-white border border-[#D8D8D866] rounded-[4px]"
          key={id}
        >
          <div className="flex justify-between items-center">
            <p className="font-bold">
              {type !== "deliverables" && (
                <span>{String(index + 1).padStart(2, "0")}. </span>
              )}
              {title}
            </p>
            <div
              className="w-[40px] h-[40px] cursor-pointer flex justify-center items-center"
              onClick={() => handleToggle(index)}
            >
              <img
                src={isOpen[index] ? icons?.minus : icons?.plus}
                alt="accordion icon"
              />
            </div>
          </div>

          {isOpen[index] && (
            <div className="flex flex-col gap-1 mt-6">
              {!media || media.length === 0 ? (
                <p className="text-[14px] leading-[24px] text-[#828282]">
                  {emptyMessage}
                </p>
              ) : (
                media?.map((item, i) =>
                  renderItem ? (
                    renderItem(item, i)
                  ) : (
                    <div>
                      <p key={item.id}>{item.name}</p>
                    </div>
                  ),
                )
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccordionList;
